import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('checkout-btn')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <section className="relative flex items-center pt-10 pb-12 md:pt-16 md:pb-16 overflow-hidden bg-background-dark" data-id="element-176">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[600px] bg-gradient-to-b from-[#3E1A00] to-transparent opacity-50 pointer-events-none" data-id="element-177" />

      <div className="container mx-auto px-4 relative z-10 flex flex-col items-center text-center" data-id="element-178">
        <FadeIn delay={0.1} data-id="element-179">
          <div className="mb-6" data-id="element-180">
            <span className="inline-block border border-primary rounded-full py-1.5 px-5 text-primary font-bold tracking-widest uppercase text-xs" data-id="element-181">
              PARA PROFESIONALES DEL FITNESS
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} className="max-w-4xl mx-auto" data-id="element-182">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black leading-tight mb-2 text-white font-heading" data-id="element-183">
            Dejá de improvisar.
          </h1>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black leading-tight mb-8 font-heading" data-id="element-184">
            <span className="text-primary" data-id="element-185">Justificá, elegí y corregí</span>{' '}
            <span className="text-white" data-id="element-186">
              cada ejercicio con criterio profesional.
            </span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.3} className="w-full max-w-3xl mx-auto mb-6" data-id="element-187">
          <div className="relative" data-id="element-188">
            <img src="https://cdn.magicpatterns.com/uploads/3mWYQm37APitSoyXGDUGuq/ngchjgj.png" alt="Pack Bases del Entrenamiento de Fuerza" className="w-full h-auto drop-shadow-2xl" data-id="element-189" />
            <div className="absolute inset-0 bg-primary/10 blur-3xl -z-10 rounded-full" data-id="element-190" />
          </div>
        </FadeIn>

        <FadeIn delay={0.4} className="max-w-3xl mx-auto mb-10" data-id="element-191">
          <p className="text-xl md:text-2xl font-medium text-gray-300" data-id="element-192">
            El recurso que le faltaba a tu formación — para que cada clase que
            des tenga el respaldo técnico que se nota.
          </p>
        </FadeIn>

        <FadeIn delay={0.5} className="w-full max-w-4xl mx-auto mb-12" data-id="element-193">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4" data-id="element-194">
            <div className="bg-card-dark rounded-xl p-4 flex items-center justify-center gap-2 border border-card-border-dark" data-id="element-195">
              <span className="text-xl" data-id="element-196">🎯</span>
              <span className="text-sm md:text-base text-white font-medium" data-id="element-197">
                Diseñá clases con lógica, no con intuición
              </span>
            </div>
            <div className="bg-card-dark rounded-xl p-4 flex items-center justify-center gap-2 border border-card-border-dark" data-id="element-198">
              <span className="text-xl" data-id="element-199">⚡</span>
              <span className="text-sm md:text-base text-white font-medium" data-id="element-200">
                Listo para usar antes de tu próxima clase
              </span>
            </div>
            <div className="bg-card-dark rounded-xl p-4 flex items-center justify-center gap-2 border border-card-border-dark" data-id="element-201">
              <span className="text-xl" data-id="element-202">🧠</span>
              <span className="text-sm md:text-base text-white font-medium" data-id="element-203">
                Más autoridad cuando te preguntan por qué
              </span>
            </div>
            <div className="bg-card-dark rounded-xl p-4 flex items-center justify-center gap-2 border border-card-border-dark" data-id="element-204">
              <span className="text-xl" data-id="element-205">🛡️</span>
              <span className="text-sm md:text-base text-white font-medium" data-id="element-206">
                Nunca más dudás frente a un alumno
              </span>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.6} className="w-full max-w-2xl mx-auto" data-id="element-207">
          <div className="flex flex-col items-center gap-4" data-id="element-208">
            <Button onClick={scrollToPricing} className="w-full md:py-6 md:text-2xl" bounce={true} data-id="element-209">
              💪 → QUIERO MI PACK AHORA
            </Button>
            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs md:text-sm text-gray-400" data-id="element-210">
              <span data-id="element-211">🔒 Pago seguro</span>
              <span className="hidden md:inline text-gray-600" data-id="element-212">—</span>
              <span data-id="element-213">⚡ Acceso en 5 minutos</span>
              <span className="hidden md:inline text-gray-600" data-id="element-214">—</span>
              <span data-id="element-215">🛡️ Garantía 7 días</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}